import { render, staticRenderFns } from "./xmas-decoration.vue?vue&type=template&id=415fc17c&scoped=true"
import script from "./xmas-decoration.vue?vue&type=script&lang=js"
export * from "./xmas-decoration.vue?vue&type=script&lang=js"
import style0 from "./xmas-decoration.vue?vue&type=style&index=0&id=415fc17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fc17c",
  null
  
)

export default component.exports